export default ({ store }) => {
  if (!store.getters['internalLinks/internalLinksLoaded']) {
    return store.dispatch('internalLinks/loadInternalLinks')
  }
}
